// extracted by mini-css-extract-plugin
export default {"dashboard":"Dashboard_dashboard__KosWL","dashboard-body":"Dashboard_dashboard-body__wbgVA","dashboard-proxy":"Dashboard_dashboard-proxy__sXPOD"};